import React from "react";
import { createRoot, type Root } from "react-dom/client";
import { ShapeToolSubMenuLayout } from "./ShapeToolSubMenuLayout";
import styles from "./shapeToolSubMenu.module.css";

type ShapeToolSubMenuProps = {
    selectedMode: string | null;
    onModeChange: (mode: string) => void;
    basicShapes: string[];
    diagramShapes: string[];
    bpmnShapes: string[];
    umlShapes: string[];
};

export class ShapeToolSubMenu {
    open(
        selectedMode: string | null,
        onModeChange: (mode: string) => void,
        basicShapes: string[],
        diagramShapes: string[],
        bpmnShapes: string[],
        umlShapes: string[],
    ) {
        this.subMenuWrapper = document.createElement("div");
        this.subMenuWrapper.classList.add(styles.shapeToolSubMenuWrapper);

        document.body.appendChild(this.subMenuWrapper);

        this.root = createRoot(this.subMenuWrapper);
        this.render(selectedMode, onModeChange, basicShapes, diagramShapes, bpmnShapes, umlShapes);
    }

    render(
        selectedMode: string | null,
        onModeChange: (mode: string) => void,
        basicShapes: string[],
        diagramShapes: string[],
        bpmnShapes: string[],
        umlShapes: string[],
    ) {
        const props: ShapeToolSubMenuProps = {
            selectedMode,
            onModeChange,
            basicShapes,
            diagramShapes,
            bpmnShapes,
            umlShapes,
        };

        const ShapeToolSubMenuLayoutElement = React.createElement(ShapeToolSubMenuLayout, props);

        if (this.root) {
            this.root.render(ShapeToolSubMenuLayoutElement);
        } else {
            throw new Error("В ShapeToolSubMenu отсутствует root");
        }
    }

    update(
        selectedMode: string | null,
        onModeChange: (mode: string) => void,
        basicShapes: string[],
        diagramShapes: string[],
        bpmnShapes: string[],
        umlShapes: string[],
    ) {
        if (this.root) {
            this.render(
                selectedMode,
                onModeChange,
                basicShapes,
                diagramShapes,
                bpmnShapes,
                umlShapes,
            );
        }
    }

    close() {
        this.root?.unmount();
        this.subMenuWrapper?.parentNode?.removeChild(this.subMenuWrapper);
        this.root = null;
        this.subMenuWrapper = null;
    }

    subMenuWrapper: HTMLElement | null = null;
    root: Root | null = null;
}
